import React, { useCallback, useEffect, useState } from "react";
import { Card, CardBody, Container, Row } from "reactstrap";
import { ToastContainer } from "react-toastify";
import { MaterialReactTable } from "material-react-table";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../Common/BreadCrumb";
import { Loader } from "../Utils/Loader";
import {
  extractedDataForUser,
  userColoumns,
} from "../UserManagement/Constant/UserManagementColoumn";
import { getAllUser } from "../../slices/UserManagement/thunk";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import { MenuItem } from "@mui/material";
import { deactivateUser } from "../../slices/UserManagement/Deactivate/thunk";
import { hasPermission } from "../Utils/UtilityFunctions";
import { useColumnSettings } from "../Utils/useColumnSettings";
import { UserCustomButtons } from "../UserManagement/UserCustomButton";
import AddEditUserModal from "../UserManagement/CreateEditUserModal";
import { resetDocumentViewState } from "../../slices/customer/documentview/reducer";
import { fetchGetUserNameSucess } from "../../slices/UserManagement/GetUserByName/reducer";
import { resendLink } from "../../slices/ResendLink/thunk";
import { resetPassword } from "../../slices/ResetPassword/thunk";
import CommonModal from "../Utils/CommonModal";
import { deleteUser } from "../../slices/UserManagement/DeleteUser/thunk";
import { activateUser } from "../../slices/UserManagement/Activate/thunk";
import { PasswordModal } from "../Customers/PasswordModal";

export default function UserListingOperator({ domain }) {
  const [loading, setLoading] = useState();
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [toastShown, setToastShown] = useState({
    success: false,
    edit: false,
    email: false
  });
  const [userDetailsModal, setUserDetailsModal] = useState(false);
  const [userId, setUserId] = useState(null);
  const [messageForPopUp, setMessageForPopUp] = useState(null);
  const [userName, setUserName] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [actionType, setActionType] = useState("");
  const [passwordModal, setPasswordModal] = useState(false);
  const [passwordUser, setPasswordUser] = useState(null);

  const dispatch = useDispatch();
  const columns = userColoumns();
  const operatorId = customerIdData();
  const location = useLocation();
  const navigate = useNavigate();
  const roleName = localStorage.getItem("roleName")

  useEffect(() => {
    dispatch(getAllUser(setLoading, operatorId, location));
  }, [dispatch]);
  const user = useSelector((state) => state?.GetAllUser?.getAllUser);
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );
  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const userPermission = hasPermission(permissionsMap, "administration", "userManagement")
  const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")

  const toggleUserDetailsModal = useCallback(() => {
    const newModalState = !userDetailsModal;
    setUserDetailsModal(newModalState);
    if (!newModalState) {
      setSelectedUser(null);
      setIsEditMode(false);
      setToastShown({ success: false, edit: false, email: false });
    }
    document.body.style.overflow = newModalState ? 'hidden' : 'auto';
  }, [userDetailsModal]);

  const handleAddUser = useCallback(() => {
    setIsEditMode(false);
    setSelectedUser(null);
    setToastShown({ success: false, edit: false, email: false });
    setUserDetailsModal(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const handleEditUser = useCallback((userData) => {
    setIsEditMode(true);
    setSelectedUser(user.find(users => users.userDetails.userId === userData.userId));
    setToastShown({ success: false, edit: false, email: false });
    setUserDetailsModal(true);
    document.body.style.overflow = 'hidden';
  }, []);

  const handleOperationSuccess = useCallback((type) => {
    setUserDetailsModal(false);
    setSelectedUser(null);
    setIsEditMode(false);
    document.body.style.overflow = 'auto';
    dispatch(getAllUser(setLoading, operatorId, location));
    setTimeout(() => {
      setToastShown({ success: false, edit: false, email: false });
    }, 1000);
  }, [dispatch, operatorId]);

  const toggleModal = (action,id) => {
    if(action === "activate" || action === "deactivate") 
      setUserId(id)
    else
      setUserName(id)
    setModalOpen(!modalOpen)
    document.body.style.overflow = 'auto'
  };

  const {
    settingsModalOpen,
    viewColumns,
    toggleSettingsModal,
    SettingsSidebar,
    CustomViewModal
  } = useColumnSettings('user', columns);

  const containsNull = viewColumns.some(value => value === undefined);
  const result = !containsNull;
  const updatedData = user.map((item) => {
    const { firstName, lastName } = item.profile;
    const { userId, userName, dialCode, phone } = item.userDetails;

    return {
      ...item,
      fullName: `${firstName} ${lastName}`,
      userId,
      userName,
      dialCode,
      phone,
    };
  });

  const listingData = extractedDataForUser(updatedData);

  return (
    <React.Fragment>
      <div id="csms">
        <Container fluid>
          <ToastContainer position="top-center" />
          {(domain === "SGCExecutiveUser" || domain === "SGCPowerUser" || domain === "SGCOperationsUser") && <UserCustomButtons
            toggleSettingsModal={toggleSettingsModal}
            Policies={user}
            navigate={navigate}
            userPermission={userPermission}
            handleAddUser={handleAddUser}
            viewPermission={viewPermission}
          />}
          <Row className="table-responsive border mt-2">
            {loading && <Loader />}
            {user ? (
              <MaterialReactTable
                muiTableHeadCellProps={{
                  sx: {
                    fontFamily: "Inter,sans-serif",
                  },
                }}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    header: "",
                    enableHiding: true,
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    fontFamily: "Inter,sans-serif",
                  },
                }}
                initialState={{
                  columnVisibility: {
                    "userDetails.userId": false,
                  },
                }}
                enableRowActions
                renderRowActionMenuItems={({ closeMenu, row }) => 
                  (domain === "SGCExecutiveUser" || domain === "SGCPowerUser" || domain === "SGCOperationsUser") ? [
                  userPermission && userPermission?.has('view') ? <MenuItem className='row-options' data-testid="update" key="view" onClick={() => { navigate(`/view-user/${row.original.userId}`,{
                    state:{
                      domain:domain
                    }
                  }); dispatch(resetDocumentViewState()); dispatch(fetchGetUserNameSucess([])) }} >
                    <i className='ri-account-circle-line me-2' /> View </MenuItem> : null,
                    userPermission ?
                      <MenuItem className='row-options' data-testid="resend" key="resend" onClick={() => { closeMenu(); setPasswordUser(row?.original); setPasswordModal(!passwordModal) }}>
                        <i className='ri-lock-password-line me-2' />Configure Password </MenuItem> : null,
                  userPermission && userPermission?.has('resend') && (row.original.status?.toLowerCase() === "unregistered") ?
                    <MenuItem className='row-options' data-testid="resend" key="resend" onClick={() => { dispatch(resendLink(setLoading, row.original.userId)) }}>
                      <i className='ri-send-plane-2-line me-2' />Resend Registration Link </MenuItem> : null,
                  // ((roleName === "systemUser" && row.original.role !== "systemUser") ||
                  //   (roleName === "providerOperationUser" && (row.original.role !== "systemUser" || row.original.role !== "providerOperationUser")) ||
                  //   (roleName === "telcoAdmin" && (row.original.role === "telcoOperationUser" || row.original.role === "telcoBusinessUser")) ||
                  //   (roleName === "telcoOperationUser" && (row.original.role === "telcoBusinessUser")) ||
                  //   (roleName === "operatorAdmin" && (row.original.role === "operatorOperationUser" || row.original.role === "operatorBusinessUser")) ||
                  //   (roleName === "operatorOperationUser" && (row.original.role === "operatorBusinessUser")) ||
                  //   (roleName === "genericAdmin" && (row.original.role === "genericOperationUser" || row.original.role === "genericBusinessUser")) ||
                  //   (roleName === "genericOperationUser" && (row.original.role === "genericBusinessUser")) ||
                  //   (roleName === "ISPOperatorAdmin" && (row.original.role === "ISPOperationUser" || row.original.role === "ISPBusinessUser")) ||
                  //   (roleName === "ISPOperationUser" && (row.original.role === "ISPBusinessUser")) ||
                    (((roleName === "SGCExecutiveUser" || roleName === "SGCPowerUser" || roleName === "SGCOperationsUser")) // to be taken care when more roles are added
                  ) ?
                    <MenuItem className='row-options' data-testid="reset" key="reset" onClick={() => { dispatch(resetPassword(row.original.userId, setLoading)) }} >
                      <i className='ri-account-circle-line me-2' /> Reset password </MenuItem> : null,
                  // Add edit option
                  userPermission && userPermission?.has('update') ?
                    <MenuItem className='row-options' data-testid="edit" key="edit" onClick={() => { handleEditUser(row.original); closeMenu(); }}>
                      <i className='ri-edit-line me-2' /> Edit </MenuItem> : null,
                  // Other menu items...
                  ((userPermission && userPermission?.has('deactivate')) && (row.original.status?.toLowerCase() === 'active') &&
                    ((roleName !== "Customer" && (row.original.role !== "telcoAdmin" && row.original.role !== "operatorAdmin" && row.original.role !== "genericAdmin" && row.original.role !== "ISPOperatorAdmin" && row.original.role !== "systemUser" && row.original.role !== "ISPPartnerAdmin")) ||
                      (roleName === "providerOperationUser" && (row.original.role !== "telcoAdmin" && row.original.role !== "operatorAdmin" && row.original.role !== "genericAdmin" && row.original.role !== "ISPOperatorAdmin" && row.original.role !== "systemUser" && row.original.role !== "ISPPartnerAdmin")) ||
                      (roleName === "telcoAdmin" && (row.original.role === "telcoOperationUser" || row.original.role === "telcoBusinessUser")) ||
                      (roleName === "telcoOperationUser" && (row.original.role === "telcoBusinessUser")) ||
                      (roleName === "operatorAdmin" && (row.original.role === "operatorOperationUser" || row.original.role === "operatorBusinessUser")) ||
                      (roleName === "operatorOperationUser" && (row.original.role === "operatorBusinessUser")) ||
                      (roleName === "genericAdmin" && (row.original.role === "genericOperationUser" || row.original.role === "genericBusinessUser")) ||
                      (roleName === "genericOperationUser" && (row.original.role === "genericBusinessUser")) ||
                      (roleName === "ISPOperatorAdmin" && (row.original.role === "ISPOperationUser" || row.original.role === "ISPBusinessUser")) ||
                      (roleName === "ISPOperationUser" && (row.original.role === "ISPBusinessUser")) ||
                      (roleName === "SGCExecutiveUser" || roleName === "SGCPowerUser" || roleName === "SGCOperationsUser")
                    )) ?
                    <MenuItem className='row-options' data-testid="deactivate" key="deactivate" onClick={() => {
                      setMessageForPopUp(`Are you sure you want to deactivate "${row.original.userName}"?`), setActionType("deactivate"), toggleModal("deactivate", row.original.userId), closeMenu()
                    }}><i className='ri-close-circle-line me-2' /> Deactivate </MenuItem> : null,
                  ((userPermission && userPermission?.has('activate')) && (row.original.status?.toLowerCase() === 'inactive') &&
                    ((roleName === "systemUser" && (row.original.role !== "telcoAdmin" && row.original.role !== "operatorAdmin" && row.original.role !== "genericAdmin" && row.original.role !== "ISPOperatorAdmin" && row.original.role !== "systemUser" && row.original.role !== "ISPPartnerAdmin")) ||
                      (roleName === "providerOperationUser" && (row.original.role !== "telcoAdmin" && row.original.role !== "operatorAdmin" && row.original.role !== "genericAdmin" && row.original.role !== "ISPOperatorAdmin" && row.original.role !== "systemUser" && row.original.role !== "ISPPartnerAdmin")) ||
                      (roleName === "telcoAdmin" && (row.original.role === "telcoOperationUser" || row.original.role === "telcoBusinessUser")) ||
                      (roleName === "telcoOperationUser" && (row.original.role === "telcoBusinessUser")) ||
                      (roleName === "operatorAdmin" && (row.original.role === "operatorOperationUser" || row.original.role === "operatorBusinessUser")) ||
                      (roleName === "operatorOperationUser" && (row.original.role === "operatorBusinessUser")) ||
                      (roleName === "genericAdmin" && (row.original.role === "genericOperationUser" || row.original.role === "genericBusinessUser")) ||
                      (roleName === "genericOperationUser" && (row.original.role === "genericBusinessUser")) ||
                      (roleName === "ISPOperatorAdmin" && (row.original.role === "ISPOperationUser" || row.original.role === "ISPBusinessUser")) ||
                      (roleName === "ISPOperationUser" && (row.original.role === "ISPBusinessUser")) ||
                      (roleName === "SGCExecutiveUser" || roleName === "SGCPowerUser" || roleName === "SGCOperationsUser")                    )) ?
                    <MenuItem className='row-options' data-testid="activate" key="activate" onClick={() => {
                      setMessageForPopUp(`Are you sure you want to Activate "${row.original.userName}"?`), setActionType("activate"), toggleModal("activate", row.original.userId), closeMenu()
                    }}><i className='ri-shut-down-line me-2' /> Activate </MenuItem> : null,
                  // (userPermission && userPermission?.has('delete') && (domain === "SGCExecutiveUser" || domain === "SGCPowerUser" || domain === "SGCOperationsUser") && (user.filter(users => users.userDetails.userName === row.original.userName)?.[0]?.operatorName === "")) 
                  (userPermission && userPermission?.has('delete') && (domain === "SGCExecutiveUser" || domain === "SGCPowerUser" || domain === "SGCOperationsUser")) 
                    ? <MenuItem className='row-options' key="delete" onClick={() => { setMessageForPopUp(`Are you sure you want to delete "${row.original.userName}"?`),setActionType("delete"), toggleModal("delete", row.original.userId), closeMenu()}}>
                      <i className="ri ri-delete-bin-5-line me-2" />{" "}
                      Delete
                    </MenuItem> : null,
                ] : 
                [<MenuItem
                    className="row-options"
                    data-testid="deactivate"
                    key="deactivate"
                    onClick={() => {
                      if(row.original.status.toLowerCase() === "active")
                      dispatch(
                        deactivateUser(
                          row.original.userId,
                          setLoading,
                          location,
                          operatorId
                        )
                      );
                      else 
                        dispatch(
                          activateUser(
                              row.original.userId,
                              setLoading, 
                              location, 
                              operatorId
                            )
                          );
                    }}
                  >
                    <i className="ri-close-circle-line me-2" /> {row.original.status.toLowerCase() === "inactive" ? "Activate" : "Deactivate"}
                  </MenuItem>]
              }
                columns={result ? columns.filter((column) => column.accessorKey ? viewColumns?.includes(column.accessorKey) : viewColumns?.includes(column.header)) : columns.filter((column) => viewColumns?.includes(column.accessorKey))}
                data={listingData}
                enableTopToolbar={false}
                enableColumnOrdering={false}
                enableColumnDragging={false}
                enableDensityToggle={false}
                enableColumnActions={true}
              />
            ) : null}
            {CustomViewModal()}
          </Row>
        </Container>
      </div>
      <AddEditUserModal
        isOpen={userDetailsModal}
        toggle={toggleUserDetailsModal}
        isEditMode={isEditMode}
        selectedUser={selectedUser}
        domain={domain}
        customRoles={[]}
        onSuccess={handleOperationSuccess}
        isUserPath={true}
        operatorUser={domain}
        operatorId={operatorId}
      />
      <div>
        <CommonModal
          modalHeader={ actionType === "delete" ? "Delete User" : actionType === "deactivate" ? "Deactivate User" : "Activate User"}
          open={modalOpen}
          toggle={toggleModal}
          buttonText={actionType === "delete" ? "Yes, Delete It" : actionType === "deactivate" ? "Deactivate": "Activate"}
          closeButtonText="Close"
          messageForPopUp={messageForPopUp}
          modalAction={() => {
            if (actionType === "delete") {
              dispatch(deleteUser(userName, setLoading, operatorId,location));
            } else if (actionType === "deactivate") {
              dispatch(deactivateUser(userId, setLoading, location, operatorId));
            } else if (actionType === "activate") {
              dispatch(activateUser(userId, setLoading, location,operatorId));
            }
            toggleModal();
          }}
        />
        {passwordUser && (
          <PasswordModal
            passwordModal={passwordModal}
            setPasswordModal={setPasswordModal}
            setLoading={setLoading}
            navigate={navigate}
            passwordCustomer={passwordUser}
            setPasswordCustomer={setPasswordUser}
          />
        )}
      </div>
    </React.Fragment>
  );
}
